import { render } from "./PageLoader.vue?vue&type=template&id=17950093&scoped=true"
const script = {}

import "./PageLoader.vue?vue&type=style&index=0&id=17950093&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17950093"]])

export default __exports__